export default __webpack_public_path__ + "static/media/bg_5.ec1598d2.png";